module.exports = __webpack_public_path__ + "static/logo-7f8840eeec87b8128792e1749c0c35ea.png";